import { render, staticRenderFns } from "./deletePropertyRightRegistration.vue?vue&type=template&id=3a9e408d&scoped=true"
import script from "./deletePropertyRightRegistration.vue?vue&type=script&lang=js"
export * from "./deletePropertyRightRegistration.vue?vue&type=script&lang=js"
import style0 from "./deletePropertyRightRegistration.vue?vue&type=style&index=0&id=3a9e408d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9e408d",
  null
  
)

export default component.exports